<template>
  <button type="button" class="btn" @click="create_cmd_dialog?.showModal()">
    Tạo lệnh
  </button>
  <dialog
    ref="create_cmd_dialog"
    class="modal"
    :aria-labelledby="`${id}-title`"
  >
    <div class="modal-box max-h-[90dvh] overflow-y-auto rounded-none">
      <h3 :id="`${id}-title`" class="mb-4 text-lg font-bold">
        Nhập lệnh muốn chạy
      </h3>
      <fieldset
        class="space-y-4"
        :disabled="action_store.loading.create_action"
      >
        <legend class="sr-only">Loại lệnh</legend>
        <div class="flex flex-wrap items-center gap-4">
          <label class="flex items-center gap-2 text-sm">
            <input
              v-model="run_with"
              type="radio"
              :name="`${id}-shell`"
              value="cmd"
              class="radio radio-sm radio-primary"
              @change="error = ''"
            />
            Lệnh Hệ thống
          </label>
          <label class="flex items-center gap-2 text-sm">
            <input
              v-model="run_with"
              type="radio"
              :name="`${id}-shell`"
              value="powershell"
              class="radio radio-sm radio-primary"
              @change="error = ''"
            />
            PowerShell
          </label>
        </div>

        <div v-if="run_with === 'powershell'">
          <label :for="`${id}-mode`" class="mb-1 block text-sm font-semibold"
            >Chế độ chạy</label
          >
          <select
            :id="`${id}-mode`"
            v-model="mode"
            class="select select-bordered w-full rounded-none"
            required
            @change="error = ''"
          >
            <option disabled value="">Chọn chế độ chạy</option>
            <option :value="0">Chạy thường</option>
            <option :value="1">BypassAMSI cách 1</option>
            <option :value="2">BypassAMSI cách 2</option>
          </select>
        </div>

        <div v-if="run_with === 'cmd'">
          <label
            :for="`${id}-command`"
            class="text-base-content/70 mb-1 block text-xs font-semibold"
            >Commandline</label
          >
          <textarea
            :id="`${id}-command`"
            v-model="command"
            class="textarea textarea-bordered h-96 w-full resize-none rounded-none"
            placeholder="Ví dụ: dir"
            @input="error = ''"
          ></textarea>
        </div>
        <div v-else>
          <PowerShellEditor
            v-model="ps_cmd"
            :max-chars="2000"
            :max-lines="150"
            @update:model-value="error = ''"
          />
          <div class="text-base-content/60 mt-1 text-xs">
            Gõ hoặc dán script PowerShell. Kết quả hiển thị ở bảng lịch sử.
          </div>
        </div>
      </fieldset>
      <p v-if="error" role="alert" class="text-error mt-3 text-sm">
        {{ error }}
      </p>
      <div class="modal-action">
        <button
          type="button"
          class="btn rounded-none"
          @click="create_cmd_dialog?.close()"
        >
          Đóng
        </button>
        <button
          type="button"
          class="btn btn-primary rounded-none"
          :disabled="action_store.loading.create_action"
          @click="submit_create"
        >
          {{ action_store.loading.create_action ? "Đang gửi…" : "Submit" }}
        </button>
      </div>
    </div>
  </dialog>
</template>

<script setup lang="ts">
import { ref, useId } from "vue";
import { use_action } from "../ExplorerV2/useAction";
import PowerShellEditor from "./PowerShellEditor.vue";

const id = useId();
const command = ref("");
const run_with = ref("cmd");
const ps_cmd = ref("");
const mode = ref<"" | 0 | 1 | 2>("");
const error = ref("");
const create_cmd_dialog = ref<HTMLDialogElement>();
const action_store = use_action();

const submit_create = async () => {
  if (action_store.loading.create_action) return;
  error.value = "";
  if (run_with.value === "powershell" && mode.value === "") {
    error.value = "Vui lòng chọn chế độ chạy!";
    return;
  }
  const args = run_with.value === "cmd" ? command.value : ps_cmd.value;
  if (!args.trim()) {
    error.value = "Vui lòng nhập câu lệnh!";
    return;
  }
  try {
    await action_store.create_action({
      type: "system_cmd",
      action: String(run_with.value === "powershell" ? mode.value : 1) as
        "0" | "1" | "2" | "3",
      args,
      run_with: run_with.value,
    });
    ps_cmd.value = "";
    mode.value = "";
    action_store.get_action_history({ type: "system_cmd" });
    create_cmd_dialog.value?.close();
  } catch {
    error.value = "Không thể tạo lệnh. Vui lòng thử lại.";
  }
};
</script>
